<template lang="pug">
  v-row
    v-col.course-list(cols="12")

      course-list-filter-block.course-list--filters(
        :initial="initialSearchLocation"
        :loading="loading"
        @filters:update="onFiltersUpdate($event)"
      )

      .course-list--body.py-5
        v-slide-y-reverse-transition(leave-absolute)
          v-row(v-if="loading && !courses.length")
            v-col(
              v-for="n in 6"
              :key="`sl${n}`"
              xl="3" lg="4" md="6" cols="12"
            )
              v-skeleton-loader(
                class="mx-auto"
                type="article, actions"
              )
        v-slide-y-reverse-transition(group class="row" leave-absolute)
          course-card(
            v-for="course in courses"
            :key="course.id"
            :course="course"
          )
      .course-list--not-found(v-if="!courses.length && !loading")
        p.text-center.grey--text.pa-4 Курсы не найдены :(

      .course-list--pagination
        .text-center(
          v-if="pagination.pageCount > 1"
        )
          v-btn(
            @click="loadMore"
            :loading="loadMoreLoading"
            :disabled="!loadMoreAvailable"
          ) Показать еще
            v-icon(right) mdi-chevron-down
        v-pagination.mb-4(
          v-if="pagination.pageCount > 1"
          v-model="pagination.currentPage"
          circle
          :length="pagination.pageCount"
          @input="getCourseList({ page: $event })"
        )

</template>

<script>
import { mapGetters } from 'vuex';

import paginationMixin from '@/mixins/pagination.mixin';
import CourseListFilterBlock from '@/modules/Courses/components/CourseListFilterBlock.vue';
import CourseCard from '@/modules/Courses/components/CourseCard.vue';

export default {
  name: 'CourseList',
  components: {
    CourseListFilterBlock,
    CourseCard,
  },
  mixins: [paginationMixin],
  data: () => ({
    courses: [],
    loading: true,
    showMine: false,
    showMineLoading: false,
    loadMoreLoading: false,
    filters: {},
  }),
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
      userRegion: 'auth/userRegion',
      userMunicipality: 'auth/userMunicipality',
    }),
    coursesHeadingText() {
      if (this.$user.isStudent && this.userMunicipality.name && JSON.stringify(this.filters) === '{}') {
        return `Курсы в вашем муниципалитете (${this.initialSearchLocation.municipality.name})`;
      }
      return 'Курсы';
    },
    /**
     * Выставляем начальные данные для фильтров поиска курсов
     * из localStorage или из профиля пользователя
     */
    initialSearchLocation() {
      const searchedLocation = JSON.parse(localStorage.getItem('CoursesSearchLocation'));

      if (searchedLocation && searchedLocation.region.id && searchedLocation.municipality.id) {
        return searchedLocation;
      }

      const locationData = {
        region: {
          id: this.userRegion.id,
          name: this.userRegion.name,
          code: this.userRegion.code,
        },
        municipality: {
          id: this.userMunicipality.id,
          name: this.userMunicipality.name,
        },
      };

      return locationData;
    },
  },
  watch: {
    showMine(val) {
      this.showMineLoading = true;
      this.pagination.currentPage = 1;
      if (val) {
        const params = {};
        params['search[course_authors]'] = this.userData.id;
        this.getCourseList(params);
        return;
      }
      this.getCourseList();
    },
  },
  methods: {
    getCourseList(params = {}, loadMore = false) {
      if (!params.page) params.page = this.pagination.currentPage;

      params.expand = 'rules,organizations,type_activity_name,is_user_enrolled,course_units_count';

      // Только активные курсы
      params['search[has_active_prior_records]'] = true;
      params['search[trained]'] = 0;

      const {
        general,
        qualification,
        professional,
        personal,
      } = this.$conf.COURSE_TYPES;
      const filtered = {
        [this.$conf.ROLES.organization.value]: [qualification, professional, personal],
        [this.$conf.ROLES.teacher.value]: this.$user.data.is_local
          ? [qualification, professional, personal] : [qualification, professional, personal],
        [this.$conf.ROLES.student.value]: this.$user.data.is_local
          ? [qualification, professional, personal] : [general],
        [this.$conf.ROLES.listener.value]: this.$user.data.is_local
          ? [qualification, professional, personal] : [qualification],
      };

      const type = {
        'search[type]': filtered[this.$user.data.role],
      };
      const result = {
        ...type, ...this.filters, ...params,
      };
      result['search[type]'] = result['search[type]'].toString();
      this.loading = true;
      this.$api.courses.getCourseList(result)
        .then((r) => {
          if (!loadMore) this.courses = [];
          this.courses.push(...r.data.data);
          this.fillPaginationData(r.headers);

          this.loading = false;
          this.showMineLoading = false;
          this.loadMoreLoading = false;
        });
    },
    loadMore() {
      this.pagination.currentPage += 1;
      this.loadMoreLoading = true;
      this.getCourseList({}, true);
    },
    onFiltersUpdate(filters) {
      this.filters = filters;
      this.getCourseList();
    },
  },
};
</script>
